import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const fetchLatestResults = async () => {
  const user = getUserDetails();
  const response = await axios.get(
    `${API_BACKEND_URL}/results?companyid=${user.companyid}`,
  );
  return response.data;
};

export const useFetchLatestResults = (queryOptions) => {
  return useQuery({
    queryKey: ["latestAPIResults"],
    queryFn: fetchLatestResults,
    ...queryOptions,
  });
};
